import React, { forwardRef } from 'react';

import DefaultLandingHeader from './DefaultLandingHeader';

function AltLandingHeader(props, ref) {
  const { cta, headertext, siteName, logoLink, menuItems } = props;
  return (
    <DefaultLandingHeader
      className="header--landingPageAlt"
      cta={cta}
      headertext={headertext}
      siteName={siteName}
      logoLink={logoLink}
      menuItems={menuItems}
      ref={ref}
    />
  );
}

export default forwardRef(AltLandingHeader);
